import { trans } from "src/resources/localization/Localization";

// export const ChangedIcon = () => <i className="fa-sharp fa-solid fa-arrow-right" style={{verticalAlign: 0, margin: '0 8px'}} />
export const ChangedIcon = () => <span className="txt-lowercase"> {trans('log.to')} </span>

export const FromText = () => <span className="txt-lowercase"> {trans('log.from')} </span>
